import api from "../api";

const TOKEN_KEY = "token";
const ROLE_KEY = "role";

// ===== helpers for localStorage token/role =====
export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  delete api.defaults.headers.common.Authorization;
}
export function setRole(role) {
  if (role) localStorage.setItem(ROLE_KEY, role);
}
export function getRole() {
  return localStorage.getItem(ROLE_KEY);
}

// Підхопити токен при завантаженні сторінки (оновленні)
const existing = getToken();
if (existing) {
  api.defaults.headers.common.Authorization = `Bearer ${existing}`;
}

// ===== API calls =====

// POST /api/auth/login
export async function login(rawEmail, rawPassword) {
  const email = String(rawEmail || "").trim().toLowerCase();
  const password = String(rawPassword || "").trim();

  const res = await api.post("/auth/login", { email, password });

  // очікуємо: { token, user: { id, email, role } }
  const data = res?.data || {};
  if (!data?.token) {
    throw new Error("LOGIN_NO_TOKEN");
  }

  setToken(data.token);
  setRole(data?.user?.role || "");

  return data; // повертаємо { token, user }
}

// GET /api/auth/me
export async function getCurrentUser() {
  const res = await api.get("/auth/me"); // Authorization виставлено вище
  return res.data;
}

// Logout (локально)
export function logout() {
  clearToken();
  localStorage.removeItem(ROLE_KEY);
}

